module.exports = __webpack_public_path__ + "static/media/PRO Gas Fees@2x.4ebb84f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/driverpolicy-images/PRO Gas Fees@2x.png
// module id = 1331
// module chunks = 0